/* eslint-disable camelcase */
export default {
    en: {
        required: 'Required',
        oneOf: 'Must be one of the following values: ${values}',
        type: 'Must be a `${type}` type',
        email: 'Must be a valid email',
        min: 'Must be at least {{count}}',
        max: 'Must be at most {{count}}',
        pattern: 'Invalid format',
        minNumber: 'Must be greater than or equal to {{count}}',
        maxNumber: 'Must be less than or equal to {{count}}',
        integer: 'Must be an integer',
        dateRangeIncomplete: 'Please select both start and end dates, or leave both empty'
    },
    no: {
        required: 'Påkrevd',
        oneOf: 'Må være en av følgende verdier: ${values}',
        type: 'Må være av typen `${type}`',
        email: 'Må være en gyldig e-post',
        min: 'Må være minst {{count}}',
        max: 'Må være maksimalt {{count}}',
        pattern: 'Ugyldig format',
        minNumber: 'Må være større enn eller lik {{count}}',
        maxNumber: 'Må være mindre enn eller lik {{count}}',
        integer: 'Må være et heltall',
        dateRangeIncomplete: 'Vennligst velg både start- og sluttdato, eller la begge stå tomme'
    },
    sv: {
        required: 'Obligatoriskt',
        oneOf: 'Måste vara en av följande värden: ${values}',
        type: 'Måste vara av typen `${type}`',
        email: 'Måste vara en giltig e-post',
        min: 'Måste vara minst {{count}}',
        max: 'Måste vara högst {{count}}',
        pattern: 'Ogiltigt format',
        minNumber: 'Måste vara större än eller lika med {{count}}',
        maxNumber: 'Måste vara mindre än eller lika med {{count}}',
        integer: 'Måste vara ett heltal',
        dateRangeIncomplete: 'Vänligen välj både start- och slutdatum, eller lämna båda tomma'
    }
} as const;
